import styles from './SubHeader.module.css';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from 'context/userContext';
import { LoginForm } from 'components/LoginForm/LoginForm';
import { AccountInfo } from 'components/AccountInfo/AccountInfo';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BrandLogo } from 'components/BrandLogo/BrandLogo';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import type { ThemeIconKey } from 'lib/themeIcons';

export const SubHeader = () => {
  const { loggedUser } = useContext(UserContext);
  const [balanceChanged, setBalanceChanged] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    setBalanceChanged(!balanceChanged);
  }, [loggedUser?.balance]);

  return (
    <div className={styles.subHeaderWrapper}>
      <div className={styles.logoWrapper} onClick={() => navigate('/')}>
        <BrandLogo theme={loggedUser?.player_theme} variant="header" />
      </div>

      {loggedUser && (
        <>
          <div className={styles.iconsWrapper}>
            <IconButton
              destinationUrl="/my-bets"
              icon="desktop-my-bets"
              label={t('my_bets_label')}
            />
            <IconButton
              destinationUrl="/deposit"
              icon="desktop-deposit"
              label={t('deposit_label')}
            />
            <IconButton
              destinationUrl="/account-statement"
              icon="desktop-account-statement"
              label={t('account_statement_label')}
            />
            <IconButton
              destinationUrl="/account-settings"
              icon="desktop-account-settings"
              label={t('account_settings_label')}
            />
            <IconButton
              destinationUrl="/theme-settings"
              icon="theme"
              label={t('theme_settings_label')}
            />
            <IconButton
              destinationUrl="/gaming-history"
              icon="desktop-gaming-history"
              label={t('gaming_history_label')}
            />
          </div>
          <AccountInfo user={loggedUser} />
        </>
      )}
      {!loggedUser && <LoginForm />}
    </div>
  );
};

interface IconButtonProps {
  destinationUrl: string;
  icon: ThemeIconKey;
  label: string;
}

const IconButton = ({ destinationUrl, icon, label }: IconButtonProps) => {
  const navigate = useNavigate();
  return (
    <span
      className={styles.iconButton}
      onClick={() => navigate(destinationUrl)}
    >
      <ThemeIcon icon={icon} alt={label} variant="desktop" />
      <label>{label}</label>
    </span>
  );
};
